import React, { useState } from "react";
import { Box, Grid, InputLabel, OutlinedInput, Paper, Tab, Tabs } from "@mui/material";
import DefaultPreviewPdfFile from "../../../../components/default-preview-pdf-file";
import { IPreviewPublicationResponse } from "../../../../model/sdp/official-daily/response/preview-publication-response";
import { formatDate } from "../../../../utils/date";

export interface IPreviewPublicationProps {
    previewPublicationResponse: IPreviewPublicationResponse;
}

function ReadOnlyField({ label, value, rows }: { label: string; value?: string | number; rows?: number }) {
    return (
        <React.Fragment>
            <InputLabel>{label}</InputLabel>
            <OutlinedInput disabled fullWidth multiline={!!rows} rows={rows} value={value ?? ''} />
        </React.Fragment>
    );
}

export default function PreviewPublication({ previewPublicationResponse }: IPreviewPublicationProps) {
    const [tabIndex, setTabIndex] = useState(0);
    const files = previewPublicationResponse?.files;
    const pdfByTab = [files?.officialDaily?.file, files?.publication?.file, files?.publicAccount?.file];

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <Paper variant="outlined" sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                    <Tabs value={tabIndex} onChange={(event, newTabIndex: number) => setTabIndex(newTabIndex)} variant="scrollable" allowScrollButtonsMobile>
                        <Tab label="Diário Oficial" />
                        <Tab label="Publicação" />
                        <Tab label="Contas públicas" />
                    </Tabs>
                    <Box sx={{ pt: 2 }}>
                        <DefaultPreviewPdfFile key={tabIndex} props={{ file: pdfByTab[tabIndex] }} />
                    </Box>
                </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
                <Paper variant="outlined" sx={{ p: 2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={3}>
                            <ReadOnlyField label="Ano" value={previewPublicationResponse?.yearPublication} />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <ReadOnlyField label="Nº edição" value={previewPublicationResponse?.editionNumber} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ReadOnlyField label="Data da publicação" value={formatDate(previewPublicationResponse?.publicationDateOn)} />
                        </Grid>
                        <Grid item xs={12}>
                            <ReadOnlyField label="Entidade" value={previewPublicationResponse?.client} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ReadOnlyField label="Categoria" value={previewPublicationResponse?.category} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ReadOnlyField label="Subcategoria" value={previewPublicationResponse?.subcategory} />
                        </Grid>
                        <Grid item xs={12}>
                            <ReadOnlyField label="Órgão de publicação" value={previewPublicationResponse?.publicAgency} />
                        </Grid>
                        <Grid item xs={12}>
                            <ReadOnlyField label="Descrição" value={previewPublicationResponse?.description} rows={15} />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    );
}
